import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import ViewMaterials from './ViewMaterials';
import { deleteMaterial, setInitialState } from '../../../actions/resources/MaterialActions';


export class MaterialMainComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            edit: false,
            showFilters: false,
            selectedIndex: 0,
            selection: [],
            name: '',
            favorit: false
        };
    }


    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    name: '',
                })
            };
        });
    };

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    handleSelection = (selection, name) => {
        this.setState({
            selection: selection,
            name: name
        })
    }

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteMaterial(this.state.selection, this.state.name);
        this.setState({ delete: false })
    }

    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }
    onEditFavorit = (ff) => {
        this.setState({ favorit: ff !== undefined ? false : !this.state.favorit })
    }

    render() {
        const { selection, favorit } = this.state;
        let content;
        content =
            <div className="table-header">
                {/* <Button
                    onClick={() => this.onSearchClick()}
                    variant="fab"
                    color="secondary"
                    aria-label="add"
                    className="action-button"
                >
                    <span className="icon-search headerIcon" />
                </Button> */}
                {selection.length == 1 &&
                    <Button
                        onClick={() => this.onEditFavorit()}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Izmeni1 headerIcon" />
                    </Button>
                }
            </div>
        return (
            <div className="page">
                {content}
                {this.state.selectedIndex === 0 && <ViewMaterials favorit={favorit} onEditFavorit={this.onEditFavorit} setSelection={this.handleSelection} edit={this.state.edit} add={this.state.add} showFilters={this.state.showFilters}
                    handleClose={this.handleClick} />}
            </div>
        )
    }

};

function mapStateToProps(state) {
    return {
        deleted: state.materialReducer.deleted,
        deleteMaterialFailed: state.materialReducer.deleteMaterialFailed,
        materialSubgroupsPostingSuccess: state.materialReducer.materialSubgroupsPostingSuccess,
        materialPostingSuccess: state.materialReducer.materialPostingSuccess,
        materialGroupPostingSuccess: state.materialReducer.materialGroupPostingSuccess
    }
}

function mapDispatchToProps(dispatch) {
    return {
        deleteMaterial: (selection, name) => dispatch(deleteMaterial(selection, name)),
        setInitialState: (component) => dispatch(setInitialState(component))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MaterialMainComponent)